<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading">
    
    <!-- breadcrumb -->
    <!-- https://stackblitz.com/edit/angular-breadcrumb-demo?file=app%2Fapp.component.html -->
    
    <div *ngIf="breadcrumbList != null && breadcrumbList.length > 0">
        <div class="center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" 
                *ngFor="let item of breadcrumbList; let i = index"
                [class.active]="i===breadcrumbList.length-1">

                <a [routerLink]="['/articles']" [queryParams]="{ category: item.reihenfolgeWeb }" *ngIf="i!==breadcrumbList.length-1">
                    {{ item.name }}
                </a>

                <span *ngIf="i===breadcrumbList.length-1">{{ item.name }}</span>
                </li>
            </ol>
        </div>
    </div>

    <!-- carousel -->
    <div *ngIf="categoryFilter != null">
        <div>
            <p-carousel 
                [value]="categoryFilter"
                [numVisible]="3"
                [numScroll]="3"
                [circular]="false">

                <ng-template let-category pTemplate="item">

                    <div class="container h-100 p-2" (click)="onSelectCategory(category)">
                        <div class="card artikelcard card-custom card-stretch gutter-b h-100 d-flex">
                            <div class=" card-body d-flex h-100 justify-content-center">
                                <div class="row center h-100">
                                    <div class="col center" align="center">
                                        <img src="data:image/jpeg;base64,{{category.bild}}" *ngIf="category.bild != null" />
                                        <img src="{{imgDummy}}" *ngIf="category.bild == null" style="max-height: 50%; max-width: 50%" />
                                    </div>
                                    <div class="col center">
                                        <h5 class="text-uppercase text-center">{{category.name}}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-template>

            </p-carousel>
        </div>

    </div>
</div>